import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupClaimRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/claims/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/group/Claims/GroupClaimPage/GroupClaimPage').then((d) => d.Route));
